import type { ButtonHTMLAttributes, MouseEvent, ReactNode } from "react";
import { playSfx } from "../sound/sfx";

export type ButtonVariant = "primary" | "ghost" | "danger" | "default";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  /**
   * Suppress the generic UI tap.
   *
   * For a button whose action has a VOICE OF ITS OWN — «تاس بریز», which answers with dice
   * landing on the felt — the tap is a second sound for one action, and you hear a click
   * followed by a clatter. Set this and let the action's own cue speak.
   */
  silent?: boolean;
};

/** The one button in the app. Reuses the `.btn` design tokens + a tap sound. */
export function Button({
  variant = "default",
  className,
  type = "button",
  children,
  onClick,
  silent = false,
  ...rest
}: Props): ReactNode {
  const classes = ["btn", variant === "default" ? "" : `btn--${variant}`, className]
    .filter(Boolean)
    .join(" ");
  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    if (!silent) playSfx("tap");
    onClick?.(event);
  };
  return (
    <button type={type} className={classes} {...rest} onClick={handleClick}>
      {children}
    </button>
  );
}
